
  // Export
  module.exports =
  {

    // Search scripts
    search:
    {
        // Method-wide scripts
        _init: function ()
        {
          APPLICATION._APPLICATION.load($('#mailing-lists'), APPLICATION._PATH_PREFIX + 'mailing-lists/lists', 'MailingLists', 'mailing-lists')
        }

    },
    EmailAdd: 
    {
        _init: function()
        {
          
          $('#company_id').not('.js-ignore').change(function ()
          {
            
            var company_id = $(this).val()
    
            var phase = $('#phase_id')
    
            if ('' === company_id)
            {
              phase.next('.dropdown-menu').html('')
            }
    
            else
            {
              
              APPLICATION._APPLICATION.loadDropdown(phase, APPLICATION._PATH_PREFIX + 'company/phases/' + company_id + '?all_option=1&phase_id=' + phase.val(), 'Development', 'dropdown')
              
            }
    
          }
          ).addClass('js-ignore').trigger('change')
          }
    }

  }